/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Toggle_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not change the schedule or event." |
*
* @param {Agent_Triggers_Toggle_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_toggle_error = /** @type {((inputs?: Agent_Triggers_Toggle_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Toggle_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auslöser konnte nicht geändert werden.")
	return /** @type {LocalizedString} */ ("Could not change the schedule or event.")
});